import React, {
  FunctionComponent,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { Link, useLocation } from "react-router-dom";
import { getContext } from "../../Helpers/Context/Context";
import "./Sidebar.css";
import { BsFillGrid1X2Fill, BsCardList } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import {
  FaUserCog,
  FaRupeeSign,
  FaLocationArrow,
  FaBuilding,
} from "react-icons/fa";
import { PiNotepad, PiChartLineUpBold } from "react-icons/pi";
import { RiHandCoinLine } from "react-icons/ri";
import { AiOutlineDollar } from "react-icons/ai";
import { MdDateRange } from "react-icons/md";
import { Badge } from "react-bootstrap";
import { AllRoutes } from "../../Routes/router";
import ProtectedMenu from "../../Helpers/PageAccess/ProtectedMenu";
import { useSelector } from "react-redux";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { AppModules } from "../../Helpers/Enums/AppModules";

const Sidebar = (props) => {
  const [isMasterExpanded, setMasterExpanded] = useState("sub-menu");
  const [isReportExpanded, setIsReportExpanded] = useState("sub-menu");
  const [isMonthlyActivitiesExpanded, setIsMonthlyActivitiesExpanded] =
    useState("sub-menu");
  const [isYearlyActivitiesExpanded, setIsYearlyActivitiesExpanded] =
    useState("sub-menu");
  const [active, setActive] = useState("");
  // const context = getContext();
  const context = useSelector((state: any) => state.updateReduxStore);

  const location = useLocation();
  useEffect(() => {
    if (props.menuOpen) {
      toggleFunc();
    } else {
      revToggleFunc("");
    }
  }, [props.menuOpen]);

  const toggleFunc = () => {
    const body = document.querySelector("body");
    body.classList.add("menubar-visible");
  };

  const revToggleFunc = (title = "") => {
    setActive(title);
    const body = document.querySelector("body");
    body.classList.remove("menubar-visible");
    setMasterExpanded("sub-menu");
    setIsReportExpanded("sub-menu");
    setIsMonthlyActivitiesExpanded("sub-menu");
    setIsYearlyActivitiesExpanded("sub-menu");
  };

  const handleMenuSubmenu = (menu) => {
    switch (menu) {
      case "Admin":
        setMasterExpanded((prev) =>
          prev === "sub-menu" ? "sub-menu expanded" : "sub-menu"
        );
        break;
      case "Report":
        setIsReportExpanded((prev) =>
          prev === "sub-menu" ? "sub-menu expanded" : "sub-menu"
        );
        break;
      case "MonthlyActivities":
        setIsMonthlyActivitiesExpanded((prev) =>
          prev === "sub-menu" ? "sub-menu expanded" : "sub-menu"
        );
        break;
      case "YearlyActivities":
        setIsYearlyActivitiesExpanded((prev) =>
          prev === "sub-menu" ? "sub-menu expanded" : "sub-menu"
        );
        break;
      default:
        break;
    }
  };

  // const MenuItemList: Array<IMenuItem> = [
  //   {
  //     link: AllRoutes.Dashboard.link,
  //     title: "Dashboard",
  //     icon: <BsFillGrid1X2Fill />,
  //     active: true,
  //   },
  //   {
  //     link: AllRoutes.UserRoleMapping.link,
  //     title: "User Role Mapping",
  //     icon: <FaUserCog />,
  //     active: false,
  //   },
  //   {
  //     link: AllRoutes.UnitCodeMaster.link,
  //     title: "Unit Code",
  //     icon: <FaUserCog />,
  //     active: false,
  //   },
  //   {
  //     link: AllRoutes.RegistrationRequest.link,
  //     title: "Member Request",
  //     icon: <FiUsers />,
  //     active: false,
  //   },
  //   {
  //     link: AllRoutes.PaymentVerification.link,
  //     title: "Payment Verification",
  //     icon: <PiNotepad />,
  //     active: false,
  //   },
  //   {
  //     link: "/profile",
  //     title: "Settlement Request",
  //     icon: <BsCardList />,
  //     active: false,
  //   },
  //   {
  //     link: "/profile",
  //     title: "Sanjeevani Yojana",
  //     icon: <PiChartLineUpBold />,
  //     active: false,
  //   },
  //   {
  //     link: "/profile",
  //     title: "Suvidha Yojana",
  //     icon: <RiHandCoinLine />,
  //     active: false,
  //   },
  //   {
  //     link: "/profile",
  //     title: "Loan Module",
  //     icon: <FaRupeeSign />,
  //     active: false,
  //   },
  //   {
  //     link: "/profile",
  //     title: "Demand & Recovery",
  //     icon: <AiOutlineDollar />,
  //     active: false,
  //   },
  //   {
  //     link: "/profile",
  //     title: "Yearly Activities",
  //     icon: <MdDateRange />,
  //     active: false,
  //   },
  // ];

  interface IMenuItem {
    link: string;
    title: string;
    icon: string | ReactNode;
    active: boolean;
  }

  const { Roles, loggedInAs, CurrentRoleId } = context;

  // const MenuItem = (props: IMenuItem) => {
  //   const { link, title, icon, active } = props;
  //   let isActive = location?.pathname?.toLowerCase() === link?.toLowerCase();
  //   return (
  //     <li onClick={() => revToggleFunc("")}>
  //       <Link
  //         to={link}
  //         style={{
  //           pointerEvents: "auto",
  //         }}
  //       >
  //         <div className={"gui-icon " + (active ? "active" : "")}>
  //           {typeof icon === "string" ? <i className={icon}></i> : icon}
  //         </div>
  //         <span className="title">{title?.toUpperCase()}</span>
  //       </Link>
  //     </li>
  //   );
  // };

  return (
    <>
      <div
        onMouseEnter={toggleFunc}
        onMouseLeave={() => revToggleFunc("")}
        id="menubar"
        className="menubar-inverse "
      >
        <div className="menubar-scroll-panel">
          <ul id="main-menu" className="gui-controls">
            {/* {MenuItemList.map((item: IMenuItem) => {
              return <MenuItem {...item} />;
            })} */}

            {/* Hide dashboard for  */}
            {/* <ProtectedMenu permittedPages={"Dashboard"} pageContext={context}>
              <li onClick={() => revToggleFunc("Dashboard")}>
                <Link
                  to={`${AllRoutes.Dashboard.link}`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div className={"gui-icon " + (active ? "Dashboard" : "")}>
                    <BsFillGrid1X2Fill />
                  </div>
                  <span className="title">Dashboard</span>
                </Link>
              </li>
            </ProtectedMenu> */}

            {Roles &&
              Roles?.find((e) => e?.RoleId === RoleEnum.Admin) &&
              loggedInAs?.value === RoleEnum.Admin && (
                <>
                  <li
                    className={isMasterExpanded}
                    onClick={() => handleMenuSubmenu("Admin")}
                  >
                    <a role="button">
                      <div className="gui-icon">
                        <i className="fas fa-tools"></i>
                      </div>
                      <span className="title">Master</span>{" "}
                    </a>
                    <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <ProtectedMenu
                        permittedPages={"UserRoleMappingDashboard"}
                        pageContext={context}
                      >
                        <li
                          onClick={() =>
                            revToggleFunc("UserRoleMappingDashboard")
                          }
                        >
                          <Link
                            to={`${AllRoutes.UserRoleMapping.link}`}
                            style={{
                              pointerEvents: "auto",
                            }}
                            className="sub-menu-item"
                          >
                            <div
                              className={
                                "gui-icon " +
                                (active ? "UserRoleMappingDashboard" : "")
                              }
                            >
                              <FaUserCog />
                            </div>
                            <span
                              style={{
                                margin: "6px 0px 0px -13px",
                                color: "black",
                              }}
                            >
                              User Role Mapping
                            </span>
                          </Link>
                        </li>
                      </ProtectedMenu>
                    </ul>
                    <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <ProtectedMenu
                        permittedPages={"UnitCodeMaster"}
                        pageContext={context}
                      >
                        <li onClick={() => revToggleFunc("UnitCodeMaster")}>
                          <Link
                            to={`${AllRoutes.UnitCodeMaster.link}`}
                            style={{
                              pointerEvents: "auto",
                            }}
                            className="sub-menu-item"
                          >
                            <div
                              className={
                                "gui-icon " + (active ? "UnitCodeMaster" : "")
                              }
                            >
                              <i
                                className="fa fa-industry"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <span
                              style={{
                                margin: "6px 0px 0px -13px",
                                color: "black",
                              }}
                            >
                              Unit Code
                            </span>
                          </Link>
                        </li>
                      </ProtectedMenu>
                    </ul>
                    <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <ProtectedMenu
                        permittedPages={"CompanyMaster"}
                        pageContext={context}
                      >
                        <li onClick={() => revToggleFunc("CompanyMaster")}>
                          <Link
                            to={`${AllRoutes.CompanyMaster.link}`}
                            style={{
                              pointerEvents: "auto",
                            }}
                            className="sub-menu-item"
                          >
                            <div
                              className={
                                "gui-icon " + (active ? "CompanyMaster" : "")
                              }
                            >
                              <FaBuilding />
                            </div>
                            <span
                              style={{
                                margin: "6px 0px 0px -13px",
                                color: "black",
                              }}
                            >
                              Company
                            </span>
                          </Link>
                        </li>
                      </ProtectedMenu>
                    </ul>
                    <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <ProtectedMenu
                        permittedPages={"SectorMaster"}
                        pageContext={context}
                      >
                        <li onClick={() => revToggleFunc("SectorMaster")}>
                          <Link
                            to={`${AllRoutes.SectorMaster.link}`}
                            style={{
                              pointerEvents: "auto",
                            }}
                            className="sub-menu-item"
                          >
                            <div
                              className={
                                "gui-icon " + (active ? "SectorMaster" : "")
                              }
                            >
                              <i
                                className="fa fa-university"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <span
                              style={{
                                margin: "6px 0px 0px -13px",
                                color: "black",
                              }}
                            >
                              Sector
                            </span>
                          </Link>
                        </li>
                      </ProtectedMenu>
                    </ul>
                    <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <ProtectedMenu
                        permittedPages={"LocationMaster"}
                        pageContext={context}
                      >
                        <li onClick={() => revToggleFunc("LocationMaster")}>
                          <Link
                            to={`${AllRoutes.LocationMaster.link}`}
                            style={{
                              pointerEvents: "auto",
                            }}
                            className="sub-menu-item"
                          >
                            <div
                              className={
                                "gui-icon " + (active ? "LocationMaster" : "")
                              }
                            >
                              <FaLocationArrow />
                            </div>
                            <span
                              style={{
                                margin: "6px 0px 0px -13px",
                                color: "black",
                              }}
                            >
                              Location
                            </span>
                          </Link>
                        </li>
                      </ProtectedMenu>
                    </ul>
                    <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <ProtectedMenu
                        permittedPages={"LoanInterest"}
                        pageContext={context}
                      >
                        <li onClick={() => revToggleFunc("LoanInterest")}>
                          <Link
                            to={`${AllRoutes.LoanInterest.link}`}
                            style={{
                              pointerEvents: "auto",
                            }}
                            className="sub-menu-item"
                          >
                            <div
                              className={
                                "gui-icon " + (active ? "LoanInterest" : "")
                              }
                            >
                              <FaRupeeSign />
                            </div>
                            <span
                              style={{
                                margin: "6px 0px 0px -13px",
                                color: "black",
                              }}
                            >
                              Loan Interest
                            </span>
                          </Link>
                        </li>
                      </ProtectedMenu>
                    </ul>
                    {/* <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <ProtectedMenu
                        permittedPages={"SanjeevaniYojana"}
                        pageContext={context}
                      >
                        <li onClick={() => revToggleFunc("SanjeevaniYojana")}>
                          <Link
                            to={`${AllRoutes.SanjeevaniBenefit.link}`}
                            style={{
                              pointerEvents: "auto",
                            }}
                            className="sub-menu-item"
                          >
                            <div
                              className={
                                "gui-icon " + (active ? "SanjeevaniYojana" : "")
                              }
                            >
                              <FaLocationArrow />
                            </div>
                            <span
                              style={{
                                margin: "6px 0px 0px -13px",
                                color: "black",
                              }}
                            >
                              Sanjeevani yojna
                            </span>
                          </Link>
                        </li>
                      </ProtectedMenu>
                    </ul> */}
                  </li>
                </>
              )}

            {/* <ProtectedMenu
              permittedPages={"RegistrationRequest"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("RegistrationRequest")}>
                <Link
                  to={`${AllRoutes.RegistrationRequest.link}`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "RegistrationRequest" : "")
                    }
                  >
                    <FiUsers />
                  </div>
                  <span className="title">Member Request</span>
                </Link>
              </li>
            </ProtectedMenu> */}

            {/* <ProtectedMenu
              permittedPages={"PaymentVerification"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("PaymentVerification")}>
                <Link
                  to={`${AllRoutes.PaymentVerification.link}`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "PaymentVerification" : "")
                    }
                  >
                    <PiNotepad />
                  </div>
                  <span className="title">Payment Verification</span>
                </Link>
              </li>
            </ProtectedMenu> */}

            <ProtectedMenu
              permittedPages={"MemberVerification"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("MemberVerification")}>
                <Link
                  to={`${AllRoutes.MemberVerification.link}`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "MemberVerification" : "")
                    }
                  >
                    <i className="fa fa-users" aria-hidden="true"></i>
                  </div>
                  <span className="title">Member Verification</span>
                </Link>
              </li>
            </ProtectedMenu>
            <ProtectedMenu
              permittedPages={"SettlementRequest"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("SettlementRequest")}>
                <Link
                  to={`/SettlementRequestDashboard`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "SettlementRequest" : "")
                    }
                  >
                    <i className="fas fa-hands-helping"></i>
                    <BsCardList />
                  </div>
                  <span className="title">Settlement Request</span>
                </Link>
              </li>
            </ProtectedMenu>

            <ProtectedMenu
              permittedPages={"YearlyActivitiesDashboard"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("YearlyActivitiesDashboard")}>
                <Link
                  to={`/YearlyDividentDashboard`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "YearlyActivitiesDashboard" : "")
                    }
                  >
                    {/* <i className="fas fa-chart-line"></i> */}
                    {/* <BsCardList /> */}
                    <i className="fas fa-chart-line"></i>
                    {/* <BsCardList /> */}
                  </div>
                  <span className="title">Yearly Divident Dashboard</span>
                </Link>
              </li>
            </ProtectedMenu>
            <ProtectedMenu
              permittedPages={"MemberDashboard"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("MemberDashboard")}>
                <Link
                  to={`/MemberDashboard`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={"gui-icon " + (active ? "MemberDashboard" : "")}
                  >
                    <i className="fas fa-list-alt"></i>
                  </div>
                  <span className="title">Member Dashboard</span>
                </Link>
              </li>
            </ProtectedMenu>
            <ProtectedMenu
              permittedPages={"SanjeevaniYojana"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("SanjeevaniYojana")}>
                <Link
                  to={`/SanjivaniMenu`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={"gui-icon " + (active ? "SanjeevaniYojana" : "")}
                  >
                    <i className="fas fa-clipboard-check"></i>
                  </div>
                  <span className="title">Sanjivani Yojana</span>
                </Link>
              </li>
            </ProtectedMenu>
            <ProtectedMenu
              permittedPages={"SanjeevaniDashboard"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("SanjeevaniDashboard")}>
                <Link
                  to={`/SanjivaniDashboard`}
                  style={{
                    pointerEvents: "auto",
                  }}
                  state={{ appModule: AppModules.SanjeevaniYojana }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "SanjeevaniDashboard" : "")
                    }
                  >
                    <i className="fas fa-clipboard-check"></i>
                  </div>
                  <span className="title">Sanjivani Approval</span>
                </Link>
              </li>
            </ProtectedMenu>
            <ProtectedMenu
              permittedPages={"SuvidhaDashboard"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("SuvidhaDashboard")}>
                <Link
                  to={`/SuvidhaDashboard`}
                  style={{
                    pointerEvents: "auto",
                  }}
                  state={{ appModule: AppModules.SuvidhaYojna }}
                >
                  <div
                    className={"gui-icon " + (active ? "SuvidhaDashboard" : "")}
                  >
                    <i className="fas fa-tasks"></i>
                  </div>
                  <span className="title">Suvidha Approval</span>
                </Link>
              </li>
            </ProtectedMenu>
            <ProtectedMenu
              permittedPages={"SuvidhaYojana"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("SuvidhaYojana")}>
                <Link
                  to={`/SuvidhaMenu`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={"gui-icon " + (active ? "SuvidhaYojana" : "")}
                  >
                    <i className="fas fa-tasks"></i>
                  </div>
                  <span className="title">Suvidha Yojana</span>
                </Link>
              </li>
            </ProtectedMenu>
            {/* <ProtectedMenu permittedPages={"LoanModule"} pageContext={context}>
              <li onClick={() => revToggleFunc("LoanDashboard")}>
                <Link
                  to={`${AllRoutes.LoanDashboard.link}`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={"gui-icon " + (active ? "LoanDashboard" : "")}
                  >
                    <RiHandCoinLine />
                  </div>
                  <span className="title">Loan Module</span>
                </Link>
              </li>
            </ProtectedMenu> */}
            <ProtectedMenu
              permittedPages={"LoanApprovalDashboard"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("LoanApprovalDashboard")}>
                <Link
                  to={`${AllRoutes.LoanApprovalDashboard.link}`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "LoanApprovalDashboard" : "")
                    }
                  >
                    <i className="fas fa-money-check-alt"></i>
                  </div>
                  <span className="title">
                    {CurrentRoleId === RoleEnum.Member
                      ? "Loan Dashboard"
                      : AllRoutes.LoanApprovalDashboard.title}
                  </span>
                </Link>
              </li>

              {/* <li onClick={() => revToggleFunc("LoanSettlementDashboard")}>
                <Link
                  to={`${AllRoutes.LoanSettlementDashboard.link}`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "LoanSettlementDashboard" : "")
                    }
                  >
                    <RiHandCoinLine />
                  </div>
                  <span className="title">
                    {CurrentRoleId === RoleEnum.Member
                      ? "Loan Settlement Dashboard"
                      : AllRoutes.LoanSettlementDashboard.title}
                  </span>
                </Link>
              </li> */}
            </ProtectedMenu>
            <ProtectedMenu
              permittedPages={"DemandRecoveryDashboard"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("DemandRecoveryDashboard")}>
                <Link
                  to={`/DemandRecovery`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "DemandRecoveryDashboard" : "")
                    }
                  >
                    <AiOutlineDollar />
                  </div>
                  <span className="title">Demand & Recovery</span>
                </Link>
              </li>
            </ProtectedMenu>
            <ProtectedMenu
              permittedPages={"InnerSettlementRequest"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("InnerSettlementRequest")}>
                <Link
                  to={`/InnerSettlementRequest`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={
                      "gui-icon " + (active ? "InnerSettlementRequest" : "")
                    }
                  >
                    {/* <AiOutlineDollar /> */}
                    <i className="far fa-handshake"></i>
                  </div>

                  <span className="title">Inner Settlement Request</span>
                </Link>
              </li>
            </ProtectedMenu>

            {Roles &&
              Roles?.find(
                (e) =>
                  e?.RoleId === RoleEnum.Admin ||
                  e?.RoleId === RoleEnum.InternalTeam
              ) &&
              (loggedInAs?.value === RoleEnum.Admin ||
                loggedInAs?.value === RoleEnum.InternalTeam) && (
                <>
                  <li className={isReportExpanded}>
                    <a
                      role="button"
                      onClick={() => handleMenuSubmenu("Report")}
                    >
                      <div className="gui-icon">
                        <i className="fas fa-tools"></i>
                      </div>
                      <span className="title">Report</span>
                    </a>
                    <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <li className={isMonthlyActivitiesExpanded}>
                        <a
                          className="SpacingBar sub-menu-item"
                          role="button"
                          onClick={() => handleMenuSubmenu("MonthlyActivities")}
                        >
                          <div className="gui-icon">
                            <i className="fas fa-tools"></i>
                          </div>
                          <span className="title">Monthly Activities</span>
                        </a>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li
                            onClick={() => revToggleFunc("NewMemberRegister")}
                          >
                            <Link
                              to={`${AllRoutes.NewMemberRegister.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "NewMemberRegister" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                New Member Register
                              </span>
                            </Link>
                          </li>
                        </ul>

                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li
                            onClick={() =>
                              revToggleFunc("SettledMemberRegister")
                            }
                          >
                            <Link
                              to={`${AllRoutes.SettledMemberRegister.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "SettledMemberRegister" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Settled Member Register
                              </span>
                            </Link>
                          </li>
                        </ul>

                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li onClick={() => revToggleFunc("SuretyRegister")}>
                            <Link
                              to={`${AllRoutes.SuretyRegister.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " + (active ? "SuretyRegister" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Surety Register
                              </span>
                            </Link>
                          </li>
                        </ul>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li onClick={() => revToggleFunc("LoanRegister")}>
                            <Link
                              to={`${AllRoutes.LoanRegister.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " + (active ? "LoanRegister" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Loan Register
                              </span>
                            </Link>
                          </li>
                        </ul>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li onClick={() => revToggleFunc("LoanPaidInExcess")}>
                            <Link
                              to={`${AllRoutes.LoanPaidInExcess.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "LoanPaidInExcess" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Loan Paid in excess
                              </span>
                            </Link>
                          </li>
                        </ul>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li onClick={() => revToggleFunc("MemberTableReco")}>
                            <Link
                              to={`${AllRoutes.MemberTableReco.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "MemberTableReco" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Member Table Reco
                              </span>
                            </Link>
                          </li>
                        </ul>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li
                            onClick={() => revToggleFunc("ShortRecoveryReport")}
                          >
                            <Link
                              to={`${AllRoutes.ShortRecoveryReport.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "ShortRecoveryReport" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Short Recovery Report
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <ul
                      className="gui-controls"
                      style={{ marginBottom: "-8px" }}
                    >
                      <li className={isYearlyActivitiesExpanded}>
                        <a
                          className="SpacingBar sub-menu-item"
                          role="button"
                          onClick={() => handleMenuSubmenu("YearlyActivities")}
                        >
                          <div className="gui-icon">
                            <i className="fas fa-tools"></i>
                          </div>
                          <span className="title">Yearly Activities</span>
                        </a>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li
                            onClick={() =>
                              revToggleFunc("DividentCalculationReport")
                            }
                          >
                            <Link
                              to={`${AllRoutes.DividentCalculationReport.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "DividentCalculationReport" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Dividend Calculation
                              </span>
                            </Link>
                          </li>
                        </ul>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li
                            onClick={() =>
                              revToggleFunc("DividentNEFTFileReport")
                            }
                          >
                            <Link
                              to={`${AllRoutes.DividentNEFTFileReport.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "DividentNEFTFileReport" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Dividend NEFT File
                              </span>
                            </Link>
                          </li>
                        </ul>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li onClick={() => revToggleFunc("HDFCToHDFCReport")}>
                            <Link
                              to={`${AllRoutes.HDFCToHDFCReport.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " + (active ? "HDFCToHDFC" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                HDFC to HDFC
                              </span>
                            </Link>
                          </li>
                        </ul>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li
                            onClick={() =>
                              revToggleFunc("DividendWarrantPrintReport")
                            }
                          >
                            <Link
                              to={`${AllRoutes.DividendWarrantPrintReport.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "DividendWarrantPrintReport" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Dividend Warrant print
                              </span>
                            </Link>
                          </li>
                        </ul>
                        <ul
                          className="gui-controls"
                          style={{ marginBottom: "-8px" }}
                        >
                          <li
                            onClick={() => revToggleFunc("ShareRegisterReport")}
                          >
                            <Link
                              to={`${AllRoutes.ShareRegisterReport.link}`}
                              style={{ pointerEvents: "auto" }}
                              className="sub-menu-item"
                            >
                              <div
                                className={
                                  "gui-icon " +
                                  (active ? "ShareRegisterReport" : "")
                                }
                              >
                                <FaUserCog />
                              </div>
                              <span
                                style={{
                                  margin: "6px 0px 0px -13px",
                                  color: "black",
                                }}
                              >
                                Share Register
                              </span>
                            </Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </>
              )}

            {/* <ProtectedMenu
              permittedPages={"YearlyActivities"}
              pageContext={context}
            >
              <li onClick={() => revToggleFunc("YearlyActivities")}>
                <Link
                  to={`/profile`}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <div
                    className={"gui-icon " + (active ? "YearlyActivities" : "")}
                  >
                    <MdDateRange />
                  </div>
                  <span className="title">Yearly Activities</span>
                </Link>
              </li>
            </ProtectedMenu> */}

            {/* <li onClick={() => revToggleFunc("LoanDetailDashboard")}>
              <Link
                to={`/LoanDetailDashboard`}
                style={{
                  pointerEvents: "auto",
                }}
              >
                <div className={"gui-icon " + (active ? "LoanDetailDashboard" : "")}>
                  <RiHandCoinLine />
                </div>
                <span className="title">LoanDetailDashboard - Remove it later</span>
              </Link>
            </li> */}

            {/* For ohter Users */}
            {/* {(loggedInAs?.label === 'Admin' ||
              loggedInAs?.label === 'Enrollment Committee' ||
              loggedInAs?.label === 'HR/HOD'||
              loggedInAs?.label === 'Internal Team') && (
              <>
                <li
                    className={isReportExpanded}
                    onClick={() => handleMenuSubmenu("Report")}
                  >
                    <a role="button">
                      <div className="gui-icon">
                        <i className="fa-solid fa-screwdriver-wrench"></i>
                      </div>
                      <span className="title">Dummy test example</span>
                    </a>
                    <ul className="gui-controls">
                      <ProtectedMenu
                        permittedPages={"UserRoleMappingDashboard"}
                        pageContext={context}
                      >
                        <li
                          onClick={() =>
                            revToggleFunc("UserRoleMappingDashboard")
                          }
                        >
                          <Link
                            to={`/Profile`}
                            style={{
                              pointerEvents: "auto",
                            }}
                          >
                            <div
                              className={"gui-icon " + (active ? "UserRoleMappingDashboard" : "")}
                            >
                              <FaUserCog />
                            </div>
                            <span className="title">Dummy test example</span>
                          </Link>
                        </li>
                      </ProtectedMenu>
                    </ul>
                  </li>
              </>
            )} */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;

//  {/* {context.loggedInAs === 1 && (
//   <li
//     className={isMasterExpanded}
//     onClick={() => handleMenuSubmenu("Admin")}>
//     <a role="button">
//       <div className="gui-icon">
//         <i className="fa-solid fa-screwdriver-wrench"></i>
//       </div>
//       <span className="title">Master</span>{" "}
//     </a>
//     <ul>
//       <li onClick={revToggleFunc}>
//         <Link
//           to="/structureType"
//           style={{
//             pointerEvents: "auto",
//           }}>
//           <div className="gui-icon"></div>
//           <span className="title">Structure Type</span>
//         </Link>
//       </li>
//       <li onClick={revToggleFunc}>
//         <Link
//           to="/ParameterDashboard"
//           style={{
//             pointerEvents: "auto",
//           }}>
//           <div className="gui-icon"></div>
//           <span className="title">Parameter</span>
//         </Link>
//       </li>
//       <li onClick={revToggleFunc}>
//         <Link
//           to="/UserDashboard"
//           style={{
//             pointerEvents: "auto",
//           }}>
//           <div className="gui-icon"></div>
//           <span className="title">User Role</span>
//         </Link>
//       </li>
//     </ul>
//   </li>
// )}

// <li
//   className={isReportExpanded}
//   onClick={() => handleMenuSubmenu("Report")}>
//   <a role="button">
//     <div className="gui-icon">
//       <i className="fa fa-file-text"></i>
//     </div>
//     <span className="title">Report</span>{" "}
//   </a>
//   <ul>
//     <li onClick={revToggleFunc}>
//       <Link
//         to="/lop"
//         style={{
//           pointerEvents: "auto",
//         }}>
//         <div className="gui-icon"></div>
//         <span className="title">List of Projects</span>
//       </Link>
//     </li>
//   </ul>
// </li> */}

// {/* <li onClick={revToggleFunc}>
//   <Link to="/invoice">
//     <div className="gui-icon">
//       <i className="fas fa-file-invoice"></i>{" "}
//     </div>
//     <span className="title">Invoices</span>
//   </Link>
// </li> */}
// {/* <li>
//   <Link to="/help">
//     <div className="gui-icon">
//       <i className="fas fa-info-circle"></i>{" "}
//     </div>
//     <span className="title">Help</span>
//   </Link>
// </li> */}
// {/* <!-- submenu --> */}
// {/* <li className="sub-menu">
//   {" "}
//   <a href="#">
//     <div className="gui-icon">
//       <i className="fas fa-home"></i>{" "}
//     </div>
//     <span className="title">Master</span>
//   </a>
//   <ul>
//     <li>
//       <a href="#" className="">
//         <span className="title">Sub Menu</span>{" "}
//       </a>
//     </li>
//     <li>
//       <a href="#" className="">
//         <span className="title">Sub Menu</span>{" "}
//       </a>
//     </li>
//   </ul>
// </li> */}
// {/* <!-- submenu --> */}
